var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImICon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_750_86",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_750_86",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABsklEQVRYCe1Wy04CQRD0YuJHmGji1RsHDcwk02NMBHr0olf/2aho4jsa9R84YBqsZalFggtzUUg2tVV0V82DnWVtbfVZrUCmFfCSTpzojY9pMLq01xLtZIqr2rqYPsfho0G4qA/VykwKwmHPHHo25EDm2YJhzIHMUZcNOZB5tmAYcyBz1NXCeR4xDmReKxhN8zxiCPSS7obX93kAj4UQ5jBhbjq0CgY9DSFsoLcWwhTNzPfD0TY0m70TPS94TAMX0zV6K7jo/lq4i/qMwL3Q3rQQcDsNfUwXlWAIv9lf9MCcw03nGvAfEWYoYG46a+CYOdD0WT74bgJhBpG56ayBG7qob83Y2YI2ywffTSAavaRHL+kdvBm6u41GY50HYHuMGi/6atvANdP4RKgRezRc7J4VZsV7HO/zNPCifSfpCjXN2N5xopfgCJ8WiJpKMITyYWHFrYPjw/LshsGifRhNQ3jVG0DUnpN0D2OYlbltgW0FNC/64STdgqOn1gDQzGbM5zXnPubIqyAXMv/7A3BRXzDrAiU9lZdqWTVlz+J+9C4Y/7Ds3Oa/08uqKUJXN/96Bb4A1Lrzb7Hpp0gAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImICon);
export default __webpack_public_path__ + "static/media/imICon.1d1a638434186f3d97712cb1d14b3ed6.svg";
export { ForwardRef as ReactComponent };